import { render, staticRenderFns } from "./KycInfo.vue?vue&type=template&id=0d7ef1a6&scoped=true"
import script from "./KycInfo.vue?vue&type=script&lang=js"
export * from "./KycInfo.vue?vue&type=script&lang=js"
import style0 from "./KycInfo.vue?vue&type=style&index=0&id=0d7ef1a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7ef1a6",
  null
  
)

export default component.exports